import { Instagram, Linkedin, MessageCircle, ArrowUpRight } from 'lucide-react';

export function Contact() {
  const socials = [
    { name: "Instagram", icon: Instagram, href: "#", color: "hover:border-pink-500/50" },
    { name: "LinkedIn", icon: Linkedin, href: "#", color: "hover:border-blue-500/50" },
    { name: "WhatsApp", icon: MessageCircle, href: "#", color: "hover:border-green-500/50" }
  ];

  return (
    <section id="contact" className="bg-slate-950 py-20 px-6 border-t border-slate-900">
      <div className="max-w-7xl mx-auto">
        <h2 className="section-title mb-4">Get In Touch</h2>
        <p className="text-slate-300 text-lg mb-12">Let's connect and create something amazing together</p>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {socials.map((social) => (
            <a
              key={social.name}
              href={social.href}
              className={`card-dark border-slate-700 ${social.color} transition-all hover:shadow-lg group`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <social.icon className="w-6 h-6 text-cyan-400" />
                  <span className="font-semibold text-white">{social.name}</span>
                </div>
                <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-cyan-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
              </div>
            </a>
          ))}
        </div>

        {/* Footer */}
        <div className="border-t border-slate-800 pt-8 text-center text-slate-400">
          <p>© 2026 Tirth Sharma. All rights reserved.</p>
        </div>
      </div>
    </section>
  );
}